import { Component, Inject, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { CdkDragDrop, moveItemInArray, transferArrayItem } from "@angular/cdk/drag-drop";

export interface DialogFIlterItem
{
	id: String,
	label: String
}

export interface DialogData
{
	dataTitle: String;
	viewList: DialogFIlterItem[];
	hideList: DialogFIlterItem[];
}

@Component({
	selector: 'filter-settings',
	templateUrl: './filter-settings.component.html',
	styleUrls: ['./filter-settings.component.scss']
})
export class FilterSettingsComponent
{
	constructor(
		public dialogRef: MatDialogRef<FilterSettingsComponent>,
		@Inject(MAT_DIALOG_DATA) public data: DialogData,
	)
	{
	}

	// LZ in a filter page, when a 'cancel' button is pressed, then this event is triggered
	onNoClick(): void
	{
		this.dialogRef.close();
	}

	// LZ: handler for filter reset (move active filters to right box)
	onResetClick(): void
	{
		// ui filters reset
		while ( this.data && this.data.hideList.length > 0 )
		{
			this.transferArrayItem(0, "view");
		}

		// update local storage

		// const filterSettings = localStorage.getItem('filter');
		// 
		// if (!!filterSettings)
		// {
			// clean filters
			// let filters = JSON.parse(filterSettings);
			// filters[this.pageReference] = {};
			// delete filters[this.pageReference]
			// localStorage.setItem('filter', JSON.stringify(filters));
			// 
		// }		
	}	

	drop(event: CdkDragDrop<DialogFIlterItem[]>)
	{
		if (event.previousContainer === event.container)
		{
			moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
		} else
		{
			transferArrayItem(
				event.previousContainer.data,
				event.container.data,
				event.previousIndex,
				event.currentIndex,
			);
		}
	}

	transferArrayItem(itemIndex: number, to: 'view' | 'hide')
	{
		if (to === 'view')
		{
			transferArrayItem(
				this.data.hideList,
				this.data.viewList,
				itemIndex,
				this.data.viewList.length,
			);
		} else
		{
			transferArrayItem(
				this.data.viewList,
				this.data.hideList,
				itemIndex,
				this.data.hideList.length,
			);
		}
	}
}
